import {PositionInterface} from '../../../shared/interfaces';
import {CheckboxControl} from '../../../shared/classes/controls';

export class AccountAccessRightControl {
    public position: PositionInterface;
    public control: CheckboxControl;

    constructor(position: PositionInterface, control: CheckboxControl) {
        this.position = position;
        this.control = control;
    }
}
